<script setup>
const props = defineProps({
    date: String
})

</script>

<template>
    <div class="text-center flex gap-2">
        <div class="border-b border-dashed border-slate-300 dark:border-slate-700 grow"></div>
        <span class="text-sm text-slate-500 font-normal leading-120">{{date}}</span>
        <div class="border-b border-dashed border-slate-300 dark:border-slate-700 grow"></div>
    </div>
</template>

<style scoped>

</style>
